import { ContractBase } from "./contract-base.model";
import { ContractFile } from "./contract-file.model";
import { SupplierFacilityType } from "./supplier-facility-type.model";
import { AuditableEntity } from "./audible-entity.model";
import { Customer } from "./customer.model";

export class FacilityType extends AuditableEntity {
    constructor(_Id?: number, _IsActive?: boolean, _Name?: string,
        _CreatedBy?: string, _CreatedDate?: Date, _UpdatedBy?: string, _UpdatedDate?: Date, _DeletedBy?: string, _DeletedDate?: Date) {

        super(_CreatedBy, _CreatedDate, _UpdatedBy, _UpdatedDate, _DeletedBy, _DeletedDate);

        this.Id = _Id;
        this.IsActive = _IsActive || true;
        this.Name = _Name;

        this.ContractBases = new Array<ContractBase>();
        this.ContractFiles = new Array<ContractFile>();
        this.Customers = new Array<Customer>();
        this.SupplierFacilityTypes = new Array<SupplierFacilityType>();
    }

    public Id: number;
    public IsActive: boolean;
    public Name: string;

    public ContractBases: ContractBase[];
    public ContractFiles: ContractFile[];
    public Customers: Customer[];
    public SupplierFacilityTypes: SupplierFacilityType[];
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/facility-type.model.ts